<script>
export default {
  data() {
    return {
      cancelled: ['REJECTED', 'WITHDRAWN']
    }
  },
  methods: {
    timelineIconName(slug, index) {
      if (this.application.status === 'COMPLETED' && this.currentStateIndex === index) {
        return 'checkmark-circle-2'
      } else if (this.cancelled.includes(slug) && this.cancelled.includes(this.application.status)) {
        return 'close-circle'
      } else if (this.currentStateIndex > index) {
        return 'checkmark-circle-2'
      } else {
        return 'clock'
      }
    },
    timelineItemClass(slug, index) {
      if (this.cancelled.includes(slug) && this.cancelled.includes(this.application.status)) {
        return 'timeline-item-danger'
      }
      if (this.application.status === 'COMPLETED' && this.currentStateIndex === index) {
        return 'timeline-item-success'
      }
      if (this.currentStateIndex > index) return 'timeline-item-success'
      if (this.currentStateIndex === index) return 'timeline-item-info'
      if (this.currentStateIndex < index) return 'timeline-item-pending'
    },
    getTitleForStatus(state) {
      if (state.slug === 'SIGNED') {
        if (this.application.payoutMethod === 'restructured') {
          return this.$t('LoanApplicationTimeline.yourLoanIsRestructured')
        }
        if (this.application.productType === 'DEALER') {
          return this.$t('LoanApplicationTimeline.dealerLoanIsSigned')
        }
      }
      return this.$t(`LoanApplicationTimeline.status.${state.title}`)
    }
  },
  computed: {
    currentStateIndex () {
      return this.submittedApplicationStates
          .map(function(e) { return e.slug })
          .indexOf(this.application.status)
    }
  }
}
</script>
